//import { Pace } from '@/components/Icons';

export interface LearnerRecordings {
  recordings: Recording[];
  totalCount: number;
  offset: number;
  limit: number;
}

export interface Recording {
  sid: string;
  exerciseID: number | null;
  dateCreated: Date;
  title: null | string;
  duration: number;
  deleted: boolean;
  hasVideo: boolean;
  status: Status;
  hasManagerReview: boolean;
  public: boolean;
}

export interface RTPace {
  Data: Pace | null;
}

export interface Pace {
  Pace: number | null;
}

export interface RTFiller {
  Data: FillerType | null;
}

export interface FillerType {
  Word: string | null;
  StartTime: number | null;
  EndTime: number | null;
}

export enum Status {
  Completed = "completed",
  Failed = "failed",
  Processing = "processing"
}
